export const TWILIGHT_IMG = "https://customer-assets.emergentagent.com/job_real-estate-photos/artifacts/exgme9b3_557-Knoll-Ct-0001-twilight.jpg";
export const TWILIGHT_BEFORE = "https://customer-assets.emergentagent.com/job_real-estate-photos/artifacts/uol1vy70_557%20Knoll%20Ct%200001.jpg";

const U = (id, w = 1800) => `https://images.unsplash.com/${id}?q=85&w=${w}&auto=format&fit=crop`;

export const SERVICE_PAGES = [
  { slug: "photography", label: "Photography", catalogId: "real_estate_photography", headline: "Stills that sell the first impression.", image: U("photo-1600210492486-724fe5c67fb0") },
  { slug: "film", label: "Film", catalogId: "property_video_tour", headline: "Cinematic property films built to be watched.", image: U("photo-1600607687920-4e2a09cf159d") },
  { slug: "aerial", label: "Aerial", catalogId: "aerial_photography", headline: "The property, the lot, the neighborhood — from above.", image: U("photo-1506947411487-a56738267384") },
  { slug: "3d-tours", label: "3D Tours", catalogId: "virtual_tour_3d", headline: "Let buyers walk every room before they visit.", image: U("photo-1600210491892-03d54c0aaf87") },
  { slug: "floor-plans", label: "Floor Plans", catalogId: "floorplan_2d", headline: "Structure, dimension and flow.", image: U("photo-1721244653721-bc681b2dfd27") },
  { slug: "twilight", label: "Twilight", catalogId: "twilight", headline: "Golden hour, on demand.", image: TWILIGHT_IMG },
  { slug: "virtual-staging", label: "Virtual Staging", catalogId: "virtual_staging", headline: "Empty rooms, fully imagined.", image: U("photo-1633330977020-2bdfb8530cc2") },
  { slug: "agent-content", label: "Agent Content", catalogId: "ai_video_social", headline: "Social-ready video for your brand.", image: U("photo-1780191751680-cdd89eef7b27") },
];

export const PROCESS_STEPS = [
  ["01", "Book", "Select your services and schedule your shoot."],
  ["02", "Create", "We photograph, film and produce your listing media."],
  ["03", "Deliver", "Your finished media is delivered through your Mandalay dashboard."],
];

export function tierPrice(svc, blocks) {
  if (!svc) return null;
  return (svc.base + (svc.increment || 0) * blocks).toFixed(2);
}

export function catalogEntry(catalog, catalogId) {
  if (!catalog) return null;
  if (catalogId === "twilight") return { ...catalog.twilight_meta, options: catalog.twilight_options, addon: true };
  if (catalogId === "virtual_staging") return { ...catalog.virtual_staging_meta, options: catalog.virtual_staging, addon: true };
  return catalog.services.find((s) => s.id === catalogId) || null;
}
